import {
  BILLING_TABS,
  CLINICAL_TABS,
  FRONT_DESK_TABS,
} from "@/lib/patientChartClinical";

export const USER_CLASSES = [
  { id: "front_desk", label: "Front Desk" },
  { id: "clinical", label: "Clinical" },
  { id: "billing", label: "Billing" },
];

export const ACCESS_LEVELS = [
  { id: "none", label: "No Access" },
  { id: "read", label: "Read" },
  { id: "write", label: "Write" },
];

export const ACCESS_AREAS = [
  { id: "front_desk", label: "Front Desk", tabs: FRONT_DESK_TABS },
  { id: "clinical", label: "Clinical", tabs: CLINICAL_TABS },
  { id: "billing", label: "Billing", tabs: BILLING_TABS },
];

export function emptyMatrix(accessLevel = "none") {
  const matrix = {};
  ACCESS_AREAS.forEach((area) => {
    matrix[area.id] = area.tabs.map((tab) => ({
      id: tab.id,
      label: tab.label,
      accessLevel,
    }));
  });
  return matrix;
}

export function setCell(matrix, areaId, subtabId, accessLevel) {
  return {
    ...matrix,
    [areaId]: (matrix[areaId] || []).map((cell) =>
      cell.id === subtabId ? { ...cell, accessLevel } : cell
    ),
  };
}

export function cellLevel(matrix, areaId, subtabId) {
  const cell = (matrix?.[areaId] || []).find((item) => item.id === subtabId);
  return cell?.accessLevel || "none";
}

export function accessIsConfigured(subtabAccess) {
  const source = subtabAccess?.source;
  return source === "organization_default" || source === "override";
}

export function filterTabsByAccess(tabs, areaId, subtabAccess) {
  if (!accessIsConfigured(subtabAccess)) return tabs;
  const levels = {};
  (subtabAccess?.matrix?.[areaId] || []).forEach((cell) => {
    levels[cell.id] = cell.accessLevel;
  });
  return tabs.filter((tab) => (levels[tab.id] || "none") !== "none");
}

export function effectiveSubtabLevel(subtabAccess, areaId, subtabId) {
  if (!accessIsConfigured(subtabAccess)) return null;
  return cellLevel(subtabAccess.matrix, areaId, subtabId);
}

export function canWriteSubtab(subtabAccess, areaId, subtabId) {
  const level = effectiveSubtabLevel(subtabAccess, areaId, subtabId);
  if (!level) return true;
  return level === "write";
}

export function canAccessSubtab(subtabAccess, areaId, subtabId) {
  if (!subtabId) return true;
  if (!accessIsConfigured(subtabAccess)) return true;
  return cellLevel(subtabAccess.matrix, areaId, subtabId) !== "none";
}

export function firstAllowedTab(tabs, areaId, subtabAccess, preferredId) {
  const visible = filterTabsByAccess(tabs, areaId, subtabAccess);
  if (preferredId && visible.some((tab) => tab.id === preferredId)) return preferredId;
  return visible[0]?.id || null;
}

export function cycleVisibleTab(tabs, current, direction) {
  if (!tabs?.length) return current;
  const index = tabs.findIndex((tab) => tab.id === current);
  const start = index < 0 ? 0 : index;
  return tabs[(start + direction + tabs.length) % tabs.length].id;
}

export function employeeOptionLabel(employee) {
  if (!employee) return "";
  const name = employee.name || "Employee";
  return employee.username ? `${name} (${employee.username})` : name;
}
